export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 p-8 md:p-10 rounded-2xl bg-background-50 border border-background-200/60">
          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              移动观影更便捷
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg">
              小草影院APP已覆盖iOS与安卓平台，随时随地高清追剧。离线缓存、夜间模式、倍速播放等实用功能一应俱全。观影追剧体验自由，不错过每一部精彩好剧。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-5">
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-8 py-3 bg-foreground-950 hover:bg-foreground-800 text-white font-medium rounded-full text-sm transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apple-fill"></i>
                iOS 下载
              </a>
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full text-sm transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-android-fill"></i>
                安卓下载
              </a>
            </div>
          </div>
          <div className="flex-1 w-full max-w-sm lg:max-w-none flex items-center justify-center">
            <div className="w-48 h-72 md:w-56 md:h-80 bg-secondary-800 rounded-3xl flex flex-col items-center justify-center gap-3">
              <div className="w-16 h-16 rounded-2xl bg-primary-500 flex items-center justify-center">
                <i className="ri-play-fill text-2xl text-white"></i>
              </div>
              <span className="text-white/60 text-xs font-medium">小草影院</span>
              <span className="text-white/30 text-[10px]">随时随地 · 高清追剧</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}